<template>
  <div class="page">
    <div class="card">
      <div class="header">
        <div class="description">
          <h2 class="title">Planos</h2>
          <p class="subtitle">Escolha o plano ideal para a sua empresa.</p>
        </div>
      </div>

      <div class="body -not-finished">
        <div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert" v-if="user.organizationPlan.cancellation_date && !isFreePlan">
          <span class="block sm:inline">Sua assinatura foi cancelada em {{ user.organizationPlan.cancellation_date | dateFormat('DD/MM/YYYY') }}.
            Você ainda poderá utilizar seus créditos conforme a política de validade dos mesmos.
            O valor por consulta vigente é de R$ {{ user.plan.price_per_consultation | currency }}.</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
        </div>
        <div class="bg-primary-100 border border-primary-400 text-primary-700 px-4 py-3 rounded relative mb-3 bg-opacity-25" role="alert" v-if="isFreePlan">
          <span class="block sm:inline">
            Seu plano atual é gratuito e tem validade de aproximadamente 7 dias.
            O valor por consulta vigente é de R$ {{ user.plan.price_per_consultation | currency }}
          </span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
        </div>
        <div class="bg-primary-100 border border-primary-400 text-primary-700 px-4 py-3 rounded relative bg-opacity-25 mb-3" role="alert" v-if="!user.organizationPlan.cancellation_date && user.organizationPlan.change_date">
          <span class="block sm:inline">A efetivação da alteração do plano acontecerá somente no próximo ciclo de cobrança ({{ user.organizationPlan.change_date | dateFormat('DD/MM/YYYY') }}).</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
        </div>
        <div class="bg-primary-100 border border-primary-400 text-primary-700 px-4 py-3 rounded relative bg-opacity-25" role="alert" v-if="!isActivePlan">
          <span class="block sm:inline">
            Seu plano atual não existe mais ou é um plano customizado para sua empresa. Clique no botão para gerenciá-lo
            <button @click="redirectToPlanDetail"
              class="btn btn-success btn-sm font-semibold text-white rounded-lg shadow-xl hover:bg-primary-800">
                Gerenciar plano
            </button>
          </span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
        </div>

        <section>
          <div class="container max-w-full mx-auto">
            <div class="max-w-full mx-auto my-3">
              <div class="relative block flex flex-col lg:flex-row items-center">
                <div :class="[(index === 1 && (!user.plan.id || user.organizationPlan.cancellation_date)) || (plan.id === user.plan.id) ? 'w-full max-w-xl md:w-2/3 sm:w-2/3 lg:w-1/4 sm:my-2 my-2 relative z-10 bg-white rounded-lg shadow-lg' : 'w-11/12 max-w-lg md:w-3/5 sm:w-3/5 lg:w-1/4 sm:my-2 my-2 relative z-0 rounded-lg shadow-lg md:-mr-4']" v-for="(plan, index) in plans">
                  <div class="bg-white text-black rounded-lg shadow-inner shadow-lg overflow-hidden">
                    <div class="text-sm leading-none rounded-t-lg bg-success-500 text-white font-semibold uppercase py-4 text-center tracking-wide" v-if="plan.id === user.plan.id && !user.organizationPlan.cancellation_date">
                      Plano atual
                    </div>
                    <div class="text-sm leading-none rounded-t-lg bg-primary-500 text-white font-semibold uppercase py-4 text-center tracking-wide" v-if="index === 1 && (!user.plan.id || user.organizationPlan.cancellation_date)">
                      Mais popular
                    </div>
                    <div class="block text-left text-sm sm:text-md max-w-sm mx-auto mt-2 text-black px-8 lg:px-6">
                      <h1 class="text-lg font-medium uppercase p-3 pb-0 text-center tracking-wide text-primary-500 font-bold">
                        {{ plan.name }}
                      </h1>
                      <h2 class="text-sm text-gray-600 text-center pb-6"><span
                        class="text-2xl text-black">R$ {{ plan.price / 100 }}</span> /mês</h2>
                    </div>

                    <div class="flex flex-wrap mt-3 px-6">
                      <ul>
                        <li class="flex items-center">
                          <div class=" rounded-full p-2 fill-current text-green-600">
                            <svg
                              class="w-6 h-6 align-middle"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                              <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                          </div>
                          <span class="text-gray-700 text-lg ml-3">R$ {{ plan.price_per_consultation | currency }} por consulta</span>
                        </li>
                      </ul>
                    </div>
                    <div class="block flex items-center p-8  uppercase">
                      <button @click="subscribe(plan.id)" v-if="user.plan.id !== plan.id || user.organizationPlan.cancellation_date"
                              class="btn btn-primary mt-3 text-lg font-semibold w-full text-white rounded-lg px-6 py-3 block shadow-xl hover:bg-primary-800">
                        {{ !user.plan.id || user.organizationPlan.cancellation_date ? 'Assinar' : 'Mudar de plano' }}
                      </button>
                      <button v-if="user.plan.id === plan.id && !user.organizationPlan.cancellation_date" @click="redirectToPlanDetail"
                              class="btn btn-success mt-3 text-lg font-semibold w-full text-white rounded-lg px-6 py-3 block shadow-xl hover:bg-primary-800">
                        Gerenciar plano
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <p class="text-gray-700">Não encontrou o plano ideal pra sua empresa, <a href="https://plexi.zendesk.com/hc/pt-br/requests/new" target="_blank">clique aqui</a> e entre em contato conosco.</p>
          </div>
        </section>
      </div>

      <confirm-change-plan ref="confirmChangePlan"/>
    </div>

    <div class="card">
      <div class="header">
        <div class="description">
          <h2 class="title">Perguntas Frequentes</h2>
        </div>
      </div>

      <div class="body">
        <p class="text-gray-800"><b>1. O valor da mensalidade é convertido em consultas?</b></p>
        <p class="text-gray-800">Sim! O valor mensal é convertido em consultas, que poderão ser utilizadas pelos próximos 30 dias, e serão cobradas de acordo com o valor de cada plano. Então, por exemplo, se você assinou o plano de R$500 e cada consulta é R$0,50, todos os meses você poderá fazer até 1000 consultas sem gastar nada a mais.</p>
        <p class="text-gray-800 mt-4"><b>2. E se eu precisar de consultas adicionais?</b></p>
        <p class="text-gray-800">Caso precise realizar mais consultas dos que as incluídas no seu plano mensal, não tem problema, você pode configurar uma recarga avulsa automática, para nunca ficar sem créditos.</p>
        <p class="text-gray-800 mt-4"><b>3. Os crédito avulsos expiram?</b></p>
        <p class="text-gray-800">Não! Os creditos avulsos não expiram, e os seus créditos da mensalidade são sempre consumidos antes, de forma a preservar os créditos extras.</p>
        <p class="text-gray-800 mt-4"><b>4. Posso pedir estorno dos créditos avulsos?</b></p>
        <p class="text-gray-800">Sim, dentro de 7 dias após o pagamento, você pode pedir o reembolso dos créditos não utilizados. Após esse período não será mais possível o reembolso e o valor ficará disponível dentro da plataforma.</p>
      </div>
    </div>

    <loader v-if="loading"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/support/components/Loader.vue';
import ConfirmChangePlan from '@/credits/components/ConfirmChangePlan.vue';
import dateFormat from '@/support/filters/dateFormat';
import currency from '@/support/filters/currency';

export default {
  name: 'Plans',

  data() {
    return {
      loading: false,
    };
  },

  async mounted() {
    this.loading = true;

    await Promise.all([
      await this.$store.dispatch('credits/plans'),
      await this.$store.dispatch('auth/loadUser'),
    ]);

    this.loading = false;
  },

  methods: {
    findPlan(id) {
      return this.plans.find((plan) => plan.id === id);
    },

    async subscribe(id) {
      if (this.user.plan && this.user.plan.price > this.findPlan(id).price) {
        if (!await this.$refs.confirmChangePlan.confirm()) { // Ao confirmar enviar para uma url q agenda a mudança
          return;
        }
      }

      await this.$router.push({
        name: 'Plan-Subscribe',
        params: { id },
      });
    },
    redirectToPlanDetail() {
      this.$router.push({
        name: 'PlanDetail',
      });
    },
  },

  computed: {
    ...mapState('credits', {
      plans: 'plans',
    }),
    ...mapState('auth', {
      user: 'user',
    }),
    isActivePlan() {
      if (this.user.plan.id === null) {
        return true;
      }

      const filtered = this.plans.filter((plan) => plan.id === this.user.plan.id);

      return filtered.length === 1;
    },
    isFreePlan() {
      return this.user.plan.id !== null && this.user.plan.name === 'Grátis';
    },
  },

  components: {
    Loader,
    ConfirmChangePlan,
  },

  filters: {
    dateFormat,
    currency,
  },
};
</script>

<style lang="scss" scoped>

</style>
